"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.page.title': 'Attivazione Account',
};
